import TrendingUp from "./TrendingUp";

export * from "./ChartArea";
export * from "./ChartBar";
export * from "./ChartBarBig";
export * from "./ChartBarDecreasing";
export * from "./ChartBarIncreasing";
export * from "./ChartBarStacked";
export * from "./ChartCandlestick";
export * from "./ChartColumn";
export * from "./ChartColumnBig";
export * from "./ChartColumnDecreasing";
export * from "./ChartColumnIncreasing";
export * from "./ChartColumnStacked";
export * from "./ChartLine";
export * from "./ChartNetwork";
export * from "./ChartNoAxesColumn";
export * from "./ChartNoAxesColumnDecreasing";
export * from "./ChartNoAxesColumnIncreasing";
export * from "./ChartNoAxesCombined";
export * from "./ChartNoAxesGantt";
export * from "./ChartPie";
export * from "./ChartScatter";
export * from "./ChartSpline";
export * from "./FolderKanban";
export * from "./Kanban";
export * from "./PanelsTopLeft";
export * from "./SquareChartGantt";
export * from "./SquareDashedKanban";
export * from "./SquareKanban";
export * from "./TrendingDown";
export * from "./TrendingUp";

export const Chartss = {
  TrendingUp,
};
